import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-apply-index-list_item" }
const _hoisted_2 = { class: "p-apply-index-card_inner" }
const _hoisted_3 = { class: "p-apply-index-card_header" }
const _hoisted_4 = { class: "p-apply-index-tag" }
const _hoisted_5 = { class: "p-apply-index-heading word_break" }
const _hoisted_6 = { class: "p-apply-index-heading_company" }
const _hoisted_7 = { class: "p-apply-index-heading_tit" }
const _hoisted_8 = { class: "p-apply-index-contents" }
const _hoisted_9 = {
  key: 0,
  class: "p-apply-index-contents_item"
}
const _hoisted_10 = { class: "p-apply-index-outline" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", { class: "__income" }, "年収", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", { class: "__place" }, "勤務地", -1)
const _hoisted_13 = { class: "word_break" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", { class: "__level" }, "応募時志望度", -1)
const _hoisted_15 = { class: "__level" }
const _hoisted_16 = {
  key: 1,
  class: "p-apply-index-contents_item"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "p-apply-index-txt" }, "求人内容はマイナビ転職に掲載の内容に準ずる", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "p-apply-index-contents_item" }
const _hoisted_20 = { class: "p-apply-index-type" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1)

import { computed } from 'vue';

import { Apply } from '@/types';
import { datefnsFormat } from '@/utils/dateFormat';
import { RouterLink } from 'vue-router';
import { APPLY_TYPE_ORDER_CA_INTRODUCE, APPLY_TYPE_ORDER_JOB_SEARCH_PUBLIC, APPLY_TYPE_ORDER_MARCH } from '@/api/services/shintyokuService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyListItem',
  props: {
    apply: null
  },
  setup(__props: any) {

const props = __props as {
  apply: Apply;
}

const formattedApplicationDate = computed(() => {
  if (props.apply.applicationDate) {
    return datefnsFormat(new Date(props.apply.applicationDate), 'yyyy/MM/dd');
  }
  return '';
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-apply-index-card", (__props.apply.selection == 'お見送り' || __props.apply.selection == 'ご辞退' || __props.apply.selection == '募集終了') ? '__closed' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (__props.apply.selection?.trim())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(["p-apply-index-tag_item", (__props.apply.selection == 'お見送り' || __props.apply.selection == 'ご辞退' || __props.apply.selection == '募集終了') ? '__closed' : ''])
                }, _toDisplayString(__props.apply.selection), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.apply.companyName), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.apply.jobTitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (__props.apply.appliedFlg != _unref(APPLY_TYPE_ORDER_MARCH))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("dl", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("dd", null, _toDisplayString(__props.apply.annualIncome), 1),
                  _hoisted_12,
                  _createElementVNode("dd", _hoisted_13, _toDisplayString(__props.apply.workLocation), 1),
                  _hoisted_14,
                  _createElementVNode("dd", _hoisted_15, _toDisplayString(__props.apply.applicationPreference), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.apply.appliedFlg == _unref(APPLY_TYPE_ORDER_MARCH))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("dl", _hoisted_20, [
              (__props.apply.appliedFlg == _unref(APPLY_TYPE_ORDER_CA_INTRODUCE))
                ? (_openBlock(), _createElementBlock("dt", _hoisted_21, "担当者おすすめから応募"))
                : _createCommentVNode("", true),
              (__props.apply.appliedFlg == _unref(APPLY_TYPE_ORDER_JOB_SEARCH_PUBLIC))
                ? (_openBlock(), _createElementBlock("dt", _hoisted_22, "求人検索から応募"))
                : _createCommentVNode("", true),
              (__props.apply.appliedFlg == _unref(APPLY_TYPE_ORDER_MARCH))
                ? (_openBlock(), _createElementBlock("dt", _hoisted_23, "マイナビ転職掲載中求人から応募"))
                : _createCommentVNode("", true),
              _createElementVNode("dd", null, "応募日：" + _toDisplayString(_unref(formattedApplicationDate)), 1)
            ])
          ])
        ]),
        (__props.apply.appliedFlg != _unref(APPLY_TYPE_ORDER_MARCH))
          ? (_openBlock(), _createBlock(_unref(RouterLink), {
              key: 0,
              class: "p-jobsearch-btn __white __link",
              to: {name: 'g00', params: {orderId: __props.apply.orderId}}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 詳細を見る"),
                _hoisted_24
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})